import styled from 'styled-components'

export const BenchmarkLegendRow = styled.div`
    padding-left: 4px;
    display: flex;
    align-items: center;
    gap: 4px;
`
